
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Input } from '@/components/ui/input';
import { TabComponentProps } from './types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const PublishingTab: React.FC<TabComponentProps> = ({ metadata, handleInputChange }) => {
  return (
    <div className="space-y-4 p-4">
      <div className="space-y-2">
        <Label htmlFor="access-type">Access Type</Label>
        <Select 
          value={metadata.paymentType || 'free'}
          onValueChange={(value) => handleInputChange('paymentType', value)}
        >
          <SelectTrigger id="access-type">
            <SelectValue placeholder="Select access type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="free">Free</SelectItem>
            <SelectItem value="subscription">Subscribers Only</SelectItem>
            <SelectItem value="micropayment">Micropayment</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {metadata.paymentType === 'micropayment' && (
        <div className="space-y-2">
          <Label htmlFor="price">Price</Label>
          <Input
            id="price"
            type="number"
            min="0.1"
            step="0.1"
            placeholder="1.99"
            value={metadata.price || ''}
            onChange={(e) => handleInputChange('price', parseFloat(e.target.value) || '')}
          />
          <p className="text-xs text-muted-foreground">Amount in USD</p>
        </div>
      )}
      
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="is-paywalled">Require Payment</Label>
          <Switch 
            id="is-paywalled" 
            checked={metadata.isPaywalled || false}
            onCheckedChange={(checked) => handleInputChange('isPaywalled', checked)}
          />
        </div>
        <p className="text-xs text-muted-foreground">
          {metadata.paymentType === 'subscription' 
            ? 'Only subscribers will have access' 
            : metadata.paymentType === 'micropayment'
              ? 'Readers will pay a one-time fee'
              : 'Everyone can access this article'}
        </p>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="comments-enabled">Enable Comments</Label>
          <Switch 
            id="comments-enabled" 
            checked={metadata.commentsEnabled !== false}
            onCheckedChange={(checked) => handleInputChange('commentsEnabled', checked)}
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label htmlFor="social-sharing">Allow Social Sharing</Label>
          <Switch 
            id="social-sharing" 
            checked={metadata.socialSharingEnabled !== false}
            onCheckedChange={(checked) => handleInputChange('socialSharingEnabled', checked)}
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="language">Language</Label>
        <Select 
          value={metadata.language || 'en'}
          onValueChange={(value) => handleInputChange('language', value)}
        >
          <SelectTrigger id="language">
            <SelectValue placeholder="Select language" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="en">English</SelectItem>
            <SelectItem value="es">Spanish</SelectItem>
            <SelectItem value="fr">French</SelectItem>
            <SelectItem value="de">German</SelectItem>
            <SelectItem value="it">Italian</SelectItem>
            <SelectItem value="pt">Portuguese</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PublishingTab;
